import { useEffect } from "react";
import { Sparkles } from "lucide-react";

const PETALS = ["p1", "p2", "p3", "p4", "p5", "p6", "p7", "p8", "p9", "p10", "p11", "p12"];

export const PerfectDayCelebration = ({ points, onClose, palette }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 5000);
    return () => clearTimeout(t);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-black/50 backdrop-blur-sm"
      onClick={onClose}
      data-testid="perfect-day-celebration"
    >
      <style>{`
        @keyframes petal-fall { 0% { transform: translateY(-10vh) rotate(0deg); opacity: 1; } 100% { transform: translateY(110vh) rotate(540deg); opacity: 0.3; } }
        @keyframes bloom-pop { 0% { transform: scale(0.4); opacity: 0; } 60% { transform: scale(1.08); } 100% { transform: scale(1); opacity: 1; } }
      `}</style>
      {PETALS.map((id, i) => (
        <span
          key={id}
          className="absolute top-0 text-2xl pointer-events-none"
          style={{
            left: `${6 + i * 8}%`,
            animation: `petal-fall ${3 + (i % 4) * 0.7}s linear ${i * 0.25}s infinite`,
          }}
        >
          {i % 3 === 0 ? "🌼" : i % 3 === 1 ? "🌱" : "✨"}
        </span>
      ))}
      <div
        className="bg-white rounded-3xl p-8 mx-6 max-w-sm text-center shadow-2xl"
        style={{ animation: "bloom-pop 0.6s ease-out" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center"
          style={{ backgroundColor: "#D9770620" }}
        >
          <Sparkles className="w-8 h-8" style={{ color: "#D97706" }} />
        </div>
        <h3 className="text-2xl font-bold mb-1" style={{ color: palette.primary }}>Perfect Day! 🌸</h3>
        <p className="text-sm opacity-80 mb-3">You completed every moment on your timeline today.</p>
        <p className="text-lg font-bold" style={{ color: "#D97706" }} data-testid="perfect-day-bonus">
          +{points} bonus bloom for your garden
        </p>
        <button
          onClick={onClose}
          className="mt-5 px-6 py-2.5 rounded-full text-sm font-bold text-white"
          style={{ backgroundColor: palette.primary }}
          data-testid="perfect-day-close-btn"
        >
          Beautiful
        </button>
      </div>
    </div>
  );
};
